import { Pipe, PipeTransform } from '@angular/core';
import { RegelWaardeDisplayPipeParams } from '../models/RegelWaardeDisplayPipeParams';

@Pipe({
  name: 'regelWaardeDisplay'
})
export class RegelWaardeDisplayPipe implements PipeTransform {
  karakteristiekNaam: string;
  operator: string;
  waarde: string;
  numeriek: boolean;

  transform(regelWaarde: string, args?: RegelWaardeDisplayPipeParams): string {
    if (regelWaarde && args.regelType === 'KarakteristiekRegel') {
      var argsParts: string[] = regelWaarde.split('|');

      if (argsParts.length > 0) {
        this.karakteristiekNaam = argsParts[0];
      }

      if (argsParts.length > 1) {
        this.operator = argsParts[1];
        switch (this.operator) {
          case '1':
            this.operator = 'Gelijk aan';
            break;
          case '2':
            this.operator = 'Bevat';
            break;
          case '3':
            this.operator = 'Groter dan';
            break;
          case '4':
            this.operator = 'Kleiner dan';
            break;
          case '5':
            this.operator = 'Een van';
            if (argsParts.length > 4) {
              var argsCount = argsParts.length;
              this.waarde = argsParts.slice(2, argsCount - 1).toString();
              this.numeriek =
                argsParts[argsCount - 1] === 'true' ? true : false;
              let uitvoer: string = `${this.karakteristiekNaam} | ${this.operator} | ${this.waarde}`;
              return uitvoer;
            }
            break;
          default:
            this.operator = '';
            break;
        }
      }
      if (argsParts.length > 2) {
        this.waarde = argsParts[2];
      }
      if (argsParts.length > 3) {
        this.numeriek = argsParts[3] === 'true' ? true : false;
      }

      let uitvoer: string = `${this.karakteristiekNaam} | ${this.operator} | ${this.waarde}`;
      return uitvoer;
    }
    if (regelWaarde && args.regelType === 'PrioriteitBrwRegel') {
      var argsParts: string[] = regelWaarde.split('|');

      if (argsParts.length > 0) {
        this.operator = argsParts[0];
        switch (this.operator) {
          case '1':
            this.operator = 'Gelijk aan';
            break;
          case '3':
            this.operator = 'Groter dan';
            break;
          case '4':
            this.operator = 'Kleiner dan';
            break;
          default:
            this.operator = '';
            break;
        }
      }

      if (argsParts.length > 1) {
        this.waarde = argsParts[1];
      }
      let uitvoer: string = `${this.operator} | ${this.waarde}`;
      return uitvoer;
    }
    return regelWaarde;
  }
}
